const getQueryParamFromUrl = (param: string) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  return params[param];
};

export { getQueryParamFromUrl };
